import { render, staticRenderFns } from "./ProductoListaItem.vue?vue&type=template&id=cf4786d8&"
import script from "./ProductoListaItem.vue?vue&type=script&lang=js&"
export * from "./ProductoListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports